export default {
  // Navbar
  'nav.home': 'Export Services',
  'nav.choHem': 'Asian Alley Kiosk',
  'nav.investment': 'Immigration Services',
  'nav.investment.main': 'Investment Residency',
  'nav.investment.detail': 'Latvia Residency Details',
  'nav.investment.partnership': 'Business Partnership',
  'nav.investment.blog': 'News & Blog',
  'nav.about': 'About Us',
  'nav.contact': 'Contact',
  'nav.consult': 'Consult',

  // Footer
  'footer.about.title': 'About The Daeg',
  'footer.about.desc': 'We are a leading company in Latvia residency investment consulting and Asian product distribution in Europe.',
  'footer.services.title': 'Services',
  'footer.services.investment': 'Latvia Investment Residency',
  'footer.services.choHem': 'Asian Alley Kiosk',
  'footer.services.export': 'Export to Europe',
  'footer.services.partnership': 'Business Partnership',
  'footer.contact.title': 'Contact',
  'footer.contact.address': 'Address',
  'footer.contact.addressValue': 'Riga, Latvia',
  'footer.contact.phone': 'Phone',
  'footer.contact.email': 'Email',
  'footer.contact.hours': 'Working Hours',
  'footer.contact.hoursValue': 'Mon - Fri: 9:00 - 18:00',
  'footer.follow.title': 'Follow Us',
  'footer.copyright': '© 2025 The Daeg International. All rights reserved.',

  // Consult Modal
  'consult.title': 'Free Consultation',
  'consult.subtitle': 'Leave your information, our experts will contact you within 24 hours',
  'consult.form.name': 'Full Name',
  'consult.form.namePlaceholder': 'Enter your full name',
  'consult.form.phone': 'Phone Number',
  'consult.form.phonePlaceholder': 'Enter your phone number',
  'consult.form.email': 'Email',
  'consult.form.emailPlaceholder': 'Enter your email',
  'consult.form.service': 'Service of Interest',
  'consult.form.servicePlaceholder': 'Select service',
  'consult.form.serviceOptions.investment': 'Latvia Investment Residency',
  'consult.form.serviceOptions.choHem': 'Asian Alley Kiosk',
  'consult.form.serviceOptions.export': 'Export to Europe',
  'consult.form.serviceOptions.partnership': 'Business Partnership',
  'consult.form.message': 'Message',
  'consult.form.messagePlaceholder': 'Tell us about your needs...',
  'consult.form.submit': 'Send Request',
  'consult.form.submitting': 'Sending...',
  'consult.success': 'Request sent successfully! We will contact you soon.',
  'consult.error': 'An error occurred. Please try again.',
};